import React from 'react';
import { Link } from 'react-router-dom';

import GameOfLifeCanvas from './gameOfLife/GameOfLifeCanvas.js';
import ECGSketch from './monitors/ECGSketch.js';
import MAPSketch from './monitors/MAPSketch.js';
import PlethSketch from './monitors/PlethSketch.js';

import './style/Home.scss';

const Intro = () => (
  <div className="flex " style={{ marginBottom: '0.5em' }}>
    <Link
      to="/about"
      className="rounded header-link"
      style={{
        margin: 'auto auto 0 0',
        padding: '0.5em',
      }}
    >
      <div className="flex col" style={{ flex: 1 }}>
        <div>Anthony Bosshardt</div>
        <div>Medical Student • Software Engineer</div>
      </div>
    </Link>
    <div className="date text-right" style={{ marginTop: 'auto' }}>
      <span id="date-value" />
    </div>
  </div>
);

const Home = () => (
  <div className="flex" style={{ height: '100vh' }}>
    <GameOfLifeCanvas />
    <div className="flex col vital-signs-container">
      <Intro />
      <ECGSketch />
      <PlethSketch />
      <MAPSketch />
    </div>
  </div>
);

export default Home;
